import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";

type Post = {
    _id: string;
    title: string;
    slug: string;
    excerpt: string;
    tags: string[];
    publishedAt: string;
};

const Blog = () => {
    const [posts, setPosts] = useState<Post[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.getPosts().then((data) => {
            setPosts(data);
            setLoading(false);
        });
    }, []);

    return (
        <div className="min-h-screen bg-(--bg-main) px-8 py-10 max-w-3xl mx-auto">
            <header className="mb-16">
                <a href="https://sambarvadai.dev" className="font-inter text-sm text-neutral-400 hover:text-neutral-600 transition-colors">
                    ← sambarvadai.dev
                </a>
                <h1 className="font-is text-5xl mt-6">writing.</h1>
                <p className="font-inter text-sm text-neutral-500 mt-2">thoughts, essays, and occasional rants.</p>
            </header>

            {loading ? (
                <p className="font-inter text-sm text-neutral-400">loading...</p>
            ) : posts.length === 0 ? (
                <p className="font-inter text-sm text-neutral-400">no posts yet.</p>
            ) : (
                <div className="flex flex-col gap-12">
                    {posts.map((post) => (
                        <Link to={`/post/${post.slug}`} key={post._id} className="group">
                            <p className="font-inter text-xs text-neutral-400 mb-2">
                                {new Date(post.publishedAt).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
                            </p>
                            <h2 className="font-is text-3xl group-hover:text-[#F4611D] transition-colors duration-200">{post.title}</h2>
                            {post.excerpt && (
                                <p className="font-inter text-sm text-neutral-500 mt-2 font-light">{post.excerpt}</p>
                            )}
                            {post.tags.length > 0 && (
                                <div className="flex gap-2 mt-3">
                                    {post.tags.map((tag) => (
                                        <span key={tag} className="font-inter text-xs px-2 py-0.5 rounded-full border border-neutral-300 text-neutral-400">
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            )}
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Blog;
